import EventEditGeneralForm from './EventEditGeneralForm';

export default EventEditGeneralForm;
